<template>
  <nd-dialog class="nd-sms" v-model="visible" :footer="false" closeBtn @close="$emit('close')">
    <div class="nd-sms-content">
      <div class="title">{{ title }}</div>

      <div class="tip" v-html="tips"></div>

      <div class="mobile" v-if="showMobile">{{ mobile | mobile }}</div>

      <div class="count-down">
        <template v-if="countDown > 0">
          <em>{{ countDown }}秒</em><span>内验证有效</span>
        </template>
      </div>

      <div class="form-item">
        <nd-input
          ref="code"
          type="pure-number"
          v-model="code"
          maxLength="6"
          placeholder="请输入验证码"
          :clearBtn="false"
        >
        </nd-input>
        <div class="retrieve" v-if="countDown === 0" @click="retrieve">重新获取</div>
      </div>

      <p class="error-tip error" v-if="errorTip">{{ errorTip }}</p>

      <nd-button class="confirm-btn small" :disabled="isDisabled" @click="confirm">确认</nd-button>
    </div>
  </nd-dialog>
</template>
<script>
var GLOBAL_TIMER = null

export default {
  name: 'nd-sms',

  props: {
    title: {
      type: String,
      default: '绑定银行卡'
    },
    value: {
      type: Boolean,
      default: false
    },

    mobile: String,

    tips: {
      type: String,
      default: '<span>验证码已发送您的手机，请查收</span>'
    },

    showMobile: {
      type: Boolean,
      default: true
    },

    duration: {
      type: Number,
      default: 120
    },

    errorTip: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      code: '',
      countDown: 0,
      visible: false,
      isDisabled: true
    }
  },

  watch: {
    value (value) {
      this.visible = value
      this.setCurrentValue(value)
      if (!this.mask) return
      if (this.value) {
        this.maskInstance.open()
      } else {
        this.maskInstance.hide()
      }
    },

    visible (value) {
      if (value) {
        this.code = ''
      }
      if (value && this.countDown === 0) {
        if (GLOBAL_TIMER) {
          clearInterval(GLOBAL_TIMER)
          this.countDown = this.duration
          this.code = ''
        }
        this.startCount()
        this.$refs['code'].focus()
      }
      this.setCurrentValue(value)
    },

    code (value) {
      if (/^\d{6}$/.test(value + '')) {
        this.isDisabled = false
      } else {
        this.isDisabled = true
      }
    }
  },

  methods: {
    setCurrentValue (value) {
      if (value === this.value) return
      this.$emit('input', value)
    },

    startCount () {
      this.countDown = this.duration
      clearInterval(GLOBAL_TIMER)
      GLOBAL_TIMER = setInterval(() => {
        this.countDown -= 1
        if (this.countDown === 0) {
          clearInterval(GLOBAL_TIMER)
          GLOBAL_TIMER = null
          this.$emit('countEnd')
        }
      }, 1000)
    },

    retrieve () {
      if (this.countDown !== 0) return
      this.$emit('retrieve', this.reset)
    },

    reset () {
      this.countDown = this.duration
      this.startCount()
      this.code = ''
    },

    confirm () {
      this.$emit('confirm', this.code)
    }
  },

  destroyed () {
    clearInterval(GLOBAL_TIMER)
    GLOBAL_TIMER = null
  }
}
</script>
<style lang="less">
@import "../../../assets/less/mixin.less";

    .nd-sms {
        .nd-sms-content {
            padding: 0 45px;
            padding-bottom: 40px;
            position: relative;

            .title {
                font-size: 42px;
                height: 72px;
                line-height: 72px;
                font-family: PingFangSC-Semibold,PingFang SC;
                font-weight: 600;
            }

            .tip {
                font-size: 28px;
                line-height: 40px;
                margin-top: 37px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc3;

                em {
                    color: @fc1;
                    font-style: normal;
                }
            }

            .mobile {
                font-size: 36px;
                height: 32px;
                line-height: 32px;
                margin-top: 7px;
                font-family: DIN-Medium,DIN;
                font-weight: 500;
            }

            .count-down {
                font-size: 24px;
                height: 33px;
                line-height: 33px;
                margin-top: 7px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc4;

                em {
                    padding-right: 3px;
                    font-style: normal;
                    color: @theme;
                }
            }

            .form-item {
                height: 120px;
                line-height: 120px;
                padding: 0 35px;
                margin-top: 33px;
                background-color: #FAFAFA;
                display: flex;
                align-items: center;

                .nd-input {
                    font-size: 46px;
                    height: 65px;
                    line-height: 65px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;

                    input {
                        font-size: 46px;
                        font-family: PingFangSC-Regular,PingFang SC;
                        font-weight: 400;
                    }
                }

                .retrieve {
                    font-size: 26px;
                    width: 105px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    color: @fc4;
                    flex-shrink: 0;

                    &.active {
                        color: @theme;
                    }
                }
            }

            .error-tip {
                font-size: 24px;
                height: 33px;
                line-height: 33px;
                bottom: 190px;
                position: absolute;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                left: 50%;
                transform: translateX(-50%);
            }

            .confirm-btn {
                width: 320px;
                height: 80px;
                line-height: 80px;
                margin: 0 auto;
                margin-top: 90px;
            }
        }
    }
</style>
